import { render } from "./JoinView.vue?vue&type=template&id=db16fd26"
import script from "./JoinView.vue?vue&type=script&lang=js"
export * from "./JoinView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__